export const modeValues = ['square', 'circle'];